import { Row } from "antd";
import { Header } from "./components/Header";
import { useParams } from "react-router-dom";
import { useFetchData } from "./hooks/useFetchData";
import { ListItems } from "./components/ListItems";
import "./styles.scss";

export const Documents = () => {
  const { accountId } = useParams();

  const { data, isLoading } = useFetchData(accountId);

  return (
    <Row className="d-block page-content doc-page">
      {accountId && <Header title="Documents" accountId={accountId} />}
      {accountId && (
        <ListItems items={data} isLoading={isLoading} accountId={accountId} />
      )}
    </Row>
  );
};
